import { gql } from '@apollo/client';

export const ENUM_QUERY = gql`
  query  fetchEnum($enumType: ID){
    fetchEnum(enumType: $enumType) {
      key
      value
    }
  }
`;